import { render, staticRenderFns } from "./ExportForm.vue?vue&type=template&id=50a9a141"
import script from "./ExportForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExportForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports